import { gql } from '@apollo/client';

export const DELETE_REPORT = gql`
  mutation deleteReport($input: DeleteReportInput) {
    deleteReport(input: $input) {
      commandId
    }
  }
`;

export const EXPORT_REPORT_LIST = gql`
  mutation exportReportList($filters: ExportReportListInput) {
    exportReportList(filters: $filters) {
      fileId
      fileName
      filePath
      fileBytes
    }
  }
`;
